<script lang="ts">
    import IdentityLogin from "./IdentityLogin.svelte";
    import IdentityLogout from "./IdentityLogout.svelte";
    import IdentityRegister from "./IdentityRegister.svelte";

    export let page: string;

    function getTitleFromPage() {
        switch (page) {
            case "register":
                return "Register";
            case "login":
                return "Log in";
            case "logout":
                return "Log out";
            case "passreset":
                return "Reset password";
        }
        return "Identity";
    }
    let title = getTitleFromPage();
</script>

<div id="tlmsp-identity">
    <div id="tlmsp-identity-holder">
        <div id="tlmsp-identity-logo">
            <img src="/img/logo.png" alt="Logo TLMSP" />
        </div>
        <div id="tlmsp-identity-title">
            {title}
        </div>
        <div id="tlmsp-identity-page">
            {#if page == "register"}
                <IdentityRegister />
            {:else if page == "login"}
                <IdentityLogin />
            {:else if page == "logout"}
                <IdentityLogout />
            {/if}
        </div>
    </div>
</div>

<style>
    #tlmsp-identity {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        background-color: #58595b;
    }
    #tlmsp-identity-holder {
        width: 400px;
        padding: 1rem;
        background-color: white;
    }
    #tlmsp-identity-title {
        font-size: 2rem;
        font-weight: bold;
    }
    #tlmsp-identity-logo img {
        max-width: 100%;
    }

    #tlmsp-identity-page {
        margin-top: 1rem;
    }

    @media (max-width: 800px) {
        #tlmsp-identity-holder {
            max-width: unset;
            width: 100%;
        }
    }
</style>
